<script setup>
import SectionViewer from '../../components/SectionViewer.vue'

// Define sections
const sections = [
  { id: 'tramites-servicios', title: '5.1 Trámites y servicios' }
]
</script>

<template>
  <SectionViewer :sections="sections" title="5. Trámites" />
</template>
